import React, { useEffect, useState } from 'react';
import { adminService } from '../services/adminService';

type Reviews = Awaited<ReturnType<typeof adminService.getAdscendReviews>>;

const REWARD_NAMES: Record<string, string> = {
  extra_pass: 'Extra pass', reveal_tool: 'Reveal Tool', pro_5050: 'Pro 50:50',
};

const AdscendReviews: React.FC = () => {
  const [reviews, setReviews] = useState<Reviews | null>(null);
  const [error, setError] = useState(false);
  const [refresh, setRefresh] = useState(0);

  useEffect(() => {
    let cancelled = false;
    setReviews(null);
    setError(false);
    adminService.getAdscendReviews().then(data => {
      if (!cancelled) setReviews(data);
    }).catch(() => {
      if (!cancelled) setError(true);
    });
    return () => { cancelled = true; };
  }, [refresh]);

  return <section className="economy-settings-group" aria-labelledby="adscend-reviews-heading">
    <h4 id="adscend-reviews-heading">Reversed Adscend offers — review required</h4>
    <p>Offers Adscend reversed after the reward was given. Nothing is taken back automatically.</p>
    <button type="button" onClick={() => setRefresh(value => value + 1)}>Refresh reviews</button>
    {error ? <p role="alert">Unable to load Adscend reviews. Please retry.</p>
      : reviews === null ? <p role="status">Loading reviews…</p> : <>
        <p>{reviews.unmatched_postbacks} postbacks could not be matched to an offer wall launch.</p>
        {reviews.review_required.length === 0 ? <p>No reversed offers need review.</p> : <ul>
          {reviews.review_required.map(item => <li key={item.attempt_id}>
            {REWARD_NAMES[item.reward] ?? item.reward} · User {item.user_id}
            {item.pro_session_id !== null ? ` · Pro session ${item.pro_session_id}` : ''}
            {item.granted_at ? ` · Granted ${new Date(item.granted_at).toLocaleString()}` : ''}
            {' · '}Attempt {item.attempt_id}
          </li>)}
        </ul>}
      </>}
  </section>;
};

export default AdscendReviews;
